import { useCallback, useEffect, useRef, useState } from 'react';

const useListHighlight = (optionCount, isOpen = true) => {
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const optionRefs = useRef([]);
  const skipScrollRef = useRef(false);

  useEffect(() => {
    if (skipScrollRef.current) {
      skipScrollRef.current = false;
      return;
    }
    if (isOpen && highlightedIndex >= 0) {
      optionRefs.current[highlightedIndex]?.scrollIntoView({ block: 'nearest' });
    }
  }, [isOpen, highlightedIndex]);

  const hoverHighlight = useCallback(
    index => {
      if (index === highlightedIndex) return;
      skipScrollRef.current = true;
      setHighlightedIndex(index);
    },
    [highlightedIndex]
  );

  const registerOption = useCallback(index => el => (optionRefs.current[index] = el), []);

  const handleArrowKey = e => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedIndex(i => Math.min(i + 1, optionCount - 1));
      return true;
    }
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedIndex(i => Math.max(i - 1, 0));
      return true;
    }
    return false;
  };

  return { highlightedIndex, setHighlightedIndex, hoverHighlight, registerOption, handleArrowKey };
};

export default useListHighlight;